import InvoicesTable from './InvoicesTable/InvoicesTable';
import PoliciesTable from './PoliciesTable/PoliciesTable';
import BillingSummary from './BillingSummary/BillingSummary';
import BillingSummaryPage from './BillingSummaryPage/BillingSummaryPage';
import MakePaymentPage from './MakePaymentPage/MakePaymentPage';
import AutomaticPayments from './AutomaticPayments/AutomaticPayments';

const billingComponentMap = {
    InvoicesTable: { component: 'InvoicesTable' },
    PoliciesTable: { component: 'PoliciesTable' },
    BillingSummary: { component: 'BillingSummary' },
    AutomaticPayments: { component: 'AutomaticPayments' }
};

const billingAdditionalComponents = {
    InvoicesTable,
    PoliciesTable,
    BillingSummary,
    AutomaticPayments
};

export {
    InvoicesTable,
    PoliciesTable,
    BillingSummary,
    BillingSummaryPage,
    MakePaymentPage,
    billingComponentMap,
    billingAdditionalComponents,
    AutomaticPayments
};
